import Vue from 'vue';
import VueCookies from 'vue-cookies';
import VueRouter from 'vue-router';
import { Persistance, MainLayout, setSession, LoadingRoute, useSessionStore } from '@/common';
import { getPlatform } from '@/common/utils';

Vue.use(VueRouter);
Vue.use(VueCookies);
let loadingInstance = null;

let router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'main',
      meta: {
        requiresAuth: true,
      },
      component: MainLayout,
      children: [
        {
          path: '/',
          redirect: () => 'home',
        },
        {
          path: '/approval-criterion',
          name: 'approval-criterion',
          component: () => import('@/views/ApprovalCriterion'),
        },
        {
          path: '/congrats',
          name: 'congrats',
          component: () => import('@/views/Congrats'),
        },
        {
          path: '/timer-task-list',
          name: 'timer-task-list',
          component: () => import('@/views/TimerTaskList'),
        },
        {
          path: '/task-timer/:Tid',
          name: 'task-timer',
          component: () => import('@/views/TaskTimer'),
        },
        {
          path: '/coins-detail/:id',
          name: 'coins-detail',
          component: () => import('@/views/AllowCoinsDetail'),
        },
      ],
    },
    { path: '*', component: () => import('@/common/views/Error404') },
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
});

function mountingLoadingScreen() {
  if (loadingInstance) return;
  loadingInstance = new Vue({
    render: (element) => element(LoadingRoute),
  }).$mount();

  window.document.body.appendChild(loadingInstance.$el);
}

function disassemblingTheLoadingScreen() {
  if (loadingInstance) {
    loadingInstance.$destroy();
    window.document.body.removeChild(loadingInstance.$el);
    loadingInstance = null;
  }
}

function goToFirstTime(to) {
  const sessionStore = useSessionStore();
  if (to.name === 'home' && sessionStore.isFirstTime && !sessionStore.children.length)
    router.replace('first-time');
}

router.beforeEach((to, from, next) => {
  mountingLoadingScreen();
  const existsToken = Persistance.getPersistedVar('AccessToken');
  const route = to.path;
  let platform = 'Unknown';
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (existsToken) {
      setSession({ route, device: getPlatform() });
      next(); // go to wherever I'm going
    } else {
      next({ name: 'login' });
    }
  } else {
    // If we already have a session and we want to go to the login, it will redirect us to home
    if (existsToken && to.matched.some((record) => record.name === 'login')) {
      next({ name: 'home' });
    } else {
      next(); // does not require auth, make sure to always call next()!
    }
  }
});

router.afterEach((to) => {
  goToFirstTime(to)
  disassemblingTheLoadingScreen();
});

// fix duplicate navigation error vue-router v3.5
router.push = async function push(location) {
  try {
    await VueRouter.prototype.push.call(this, location);
  } catch (err) {
    if (err.name !== 'NavigationDuplicated') throw err;
  }
};

export default router;
